import { useState, useEffect } from 'react';

import { setTag } from '@sentry/nextjs';

import {
  analysisUserPropertyKeys,
  setAnalysisUserProperty,
} from 'utils/analysis/analysis';

import { useStorage } from './useStorage';

enum DEBUG_MODE {
  DISABLED = '0',
  ENABLED = '1',
}

/**
 * デバッグモードが有効かどうかを返すカスタムフック
 */
export const useDebugModeEnabled = () => {
  const { value } = useStorage(
    'debugModeEnabled',
    DEBUG_MODE.DISABLED,
    'local',
  );
  const debugModeEnabled = value === DEBUG_MODE.ENABLED;
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  useEffect(() => {
    setIsInitialized(true);

    setAnalysisUserProperty(
      analysisUserPropertyKeys.DEBUG_MODE_ENABLED,
      debugModeEnabled,
    );
    setTag('debugModeEnabled', debugModeEnabled);
  }, [debugModeEnabled]);

  return { debugModeEnabled, isInitialized };
};
